export default __webpack_public_path__ + "static/media/ic_gambia.011be66e.svg";